let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kT1bF")).then(() => parcelRequire('5vfS0'));